<template>
  <div>
    <Card>
      <Row>
        <Button type="info" @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate
        :columns="columns"
        :data="depots"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
    <Modal v-model="modalShow" @on-ok="handleSubmit" :title="$t('pages_depots_index_467')">
      <Form ref="depot" :model="depot" :label-width="80">
        <Form-item :label="$t('pages_depots_index_468')" prop="name">
          <Input type="text" v-model="depot.name" />
        </Form-item>
        <Form-item :label="$t('pages_depots_index_469')" prop="name">
          <Input type="text" v-model="depot.address" />
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_depots_index_468'),
          key: 'name',
          width: 300
        },
        {
          title: i18n.t('pages_depots_index_468'),
          key: 'address'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapGetters('depot', ['depot', 'depots', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('depot', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('depot', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.depot)
      } else if (this.formType === 'new') {
        await this.create(this.depot)
      }
      this.modalShow = false
    }
  }
}
</script>
